/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface UpdateServicesRequestSeatsChildSeatsInner {
  /**
   * 更新区分<br/> request：登録<br/> cancel：削除
   */
  operation: UpdateServicesRequestSeatsChildSeatsInner.OperationEnum;
  /**
   * 搭乗者ID
   */
  travelerId: string;
  /**
   * チャイルドシート種類<br/> mlit：日本の国土交通省(MLIT)承認<br/> fmvss：米国(FMVSS)承認<br/> ece：欧州(ECE R44/UN R44)承認<br/> cares：CARES<br/> ※登録内容は、ASWDBから取得
   */
  type: string;
}
export namespace UpdateServicesRequestSeatsChildSeatsInner {
  export type OperationEnum = 'request' | 'cancel';
  export const OperationEnum = {
    Request: 'request' as OperationEnum,
    Cancel: 'cancel' as OperationEnum,
  };
}
